import StarRating from "vue-star-rating";
import { Carousel, Slide } from "vue-carousel";
import { mapGetters } from "vuex";
import moment from "moment";

export default {
    name: "promotions-slider",
    props: ["sliders", "items", "startDate", "endDate", "productItem"],
    data() {
        return {
            currentSlide: 0,
            discount: false,
            title: "",
            description: "",
            test: "test",
        };
    },
    components: {
        Carousel,
        Slide,
        StarRating,
    },
    watch: {},
    methods: {
        pageChange(slide) {
            this.currentSlide = slide;
        },
    },
    computed: {
        ...mapGetters({
            getCurrentList: "promotions/getCurrentList",
            getList: `promotions/getList`,
            productLoading: "promotions/productLoading",
            productsLength: `promotions/productsLength`,
        }),
        getProducts() {
            let arr = [];
            for (let i in this.getList) {
                this.startDate = this.getList[i].start_date;
                this.endDate = this.getList[i].end_date;
                this.title = this.getList[i].title;
                this.description = this.getList[i].description;

                for (let j in this.getList[i].products.data) {
                    if (this.getList[i].slug === this.$route.params.promo) {
                        arr.push(this.getList[i].products.data[j]);
                        this.productItem = this.getList[i].products.data[j];
                    }
                    return arr;
                }
            }
        },
        getCurrentPrice() {
            if (this.startDate) {
                let period = `${this.productItem.sale_start.slice(0, -8)},${this.productItem.sale_end.slice(0, -8)}`;
                let currentDate = new Date().toISOString().split("T")[0];
                let dates = period.split(",");
                let result = moment(currentDate).isBetween(dates[0], dates[1], null, "()");

                if (!result && this.product.discount_price !== 0) {
                    return this.product.price;
                } else {
                    this.discount = true;
                    return this.product.discount_price;
                }
            } else {
                return this.product.price;
            }
        },
        getUnit() {
            if (this.productItem.unit !== null) {
                return "/" + this.productItem.unit;
            }
        },
    },
};
